import React, { useState } from 'react';

import { useDisclosure } from '@mantine/hooks';
import { useAuth } from 'context/auth-context';
import { PayrollReport as PayrollReportType } from 'types';

import DrawerStaffDetailPayoutReport from './components/DrawerStaffDetailPayoutReport';
import PayrollReportPageHeader from './components/PayrollReportPageHeader';
import PayrollReportTable from './components/PayrollReportTable';

const PayrollReport = (): JSX.Element => {
  const { hasPerm } = useAuth();
  const payrollPerm = hasPerm('PayrollMutate');

  const [payrollPeriod, setPayrollPeriod] = useState<string | null>(null);
  const [staff, setStaff] = useState<PayrollReportType>();
  const [isDetailDrawerOpen, { open: openDetailDrawer, close: closeDetailDrawer }] = useDisclosure(false);
  const [, setOrderingValue] = useState<string>('staffName');

  const handleOpenDetail = (s: PayrollReportType): void => {
    setStaff(s);
    openDetailDrawer();
  };
  return (
    <>
      <PayrollReportPageHeader
        permission={payrollPerm}
        payrollPeriod={payrollPeriod}
        setPayrollPeriod={setPayrollPeriod}
      />

      <PayrollReportTable
        payrollPeriod={payrollPeriod}
        handleOpenDetail={handleOpenDetail}
        setOrderingValue={setOrderingValue}
      />
      <DrawerStaffDetailPayoutReport
        staff={staff}
        initialPayrollPeriod={payrollPeriod}
        setInitialPayrollPeriod={setPayrollPeriod}
        opened={isDetailDrawerOpen}
        close={closeDetailDrawer}
        permission={payrollPerm}
      />
    </>
  );
};

export default PayrollReport;
